import { render } from "./InstanceVolumesStoragePoolSelectListView.vue?vue&type=template&id=68d3ef2a&scoped=true"
import script from "./InstanceVolumesStoragePoolSelectListView.vue?vue&type=script&lang=js"
export * from "./InstanceVolumesStoragePoolSelectListView.vue?vue&type=script&lang=js"

import "./InstanceVolumesStoragePoolSelectListView.vue?vue&type=style&index=0&id=68d3ef2a&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68d3ef2a"]])

export default __exports__